import React from 'react'
import { connect } from 'react-redux';
import config from '../../config';
import { getOperation } from './librairies';
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'

function Graphe2({ graphe2 }) {


    return (
        !graphe2  || graphe2 === ""?
        <div></div>
        :
            <HighchartsReact
                highcharts={Highcharts}
                options={graphe2}
            />
    )
}

function mapStateToProps(state) {

    return {
        graphe2: state.graphe2,
    }
}

export default connect(mapStateToProps)(Graphe2);

export async function graphe2(theme1, theme2, theme3, terriroire, agrandir = false, fonctionfincreation = null) {
    if (theme1 || theme2 || theme3) {

        let condition1 = "";
        let condition2 = "";
        let condition3 = "";
        let donneesvariable1 = theme1;
        let donneesvariable2 = theme2;
        let donneesvariable3 = theme3;
        var filtre = terriroire !== "BDR" ? " amp=1 " : " dep13=1 ";
        var o1 = getOperation(donneesvariable1);
        var o2 = getOperation(donneesvariable2);
        var o3 = getOperation(donneesvariable3);
    
        var conditiontotal = "NOT(1=1 ";
    
        if (theme1) {
            condition1 = donneesvariable1.colonne + " is not null AND " + donneesvariable1.colonne + o1.signe + o1.valeur + " ";
            conditiontotal += " AND " + donneesvariable1.colonne + " IS NULL";
        }
    
        if (theme2) {
            condition2 = donneesvariable2.colonne + " is not null AND " + donneesvariable2.colonne + o2.signe + o2.valeur + " ";
            conditiontotal += " AND " + donneesvariable2.colonne + " IS NULL";
        }
    
        if (theme3) {
            condition3 = donneesvariable3.colonne + " is not null AND " + donneesvariable3.colonne + o3.signe + o3.valeur + " ";
            conditiontotal += " AND " + donneesvariable3.colonne + " IS NULL";
        }
        conditiontotal += ") AND "
        var requette = "SELECT * FROM (SELECT COALESCE(SUM(i_pnew_pop),0) total FROM maille.mailles WHERE " + conditiontotal + filtre + ") total,";
    
    
        if (theme1) {
            requette += "( SELECT COALESCE(SUM(i_pnew_pop),0) theme1 FROM maille.mailles indicateur WHERE " + condition1;
            if (condition2 !== "")
                requette += " AND NOT (" + condition2 + ")";
            if (condition3 !== "")
                requette += " AND NOT (" + condition3 + ")";
    
            requette += " AND " + filtre + ") theme1,";
        } else
            requette += "(SELECT 0 as theme1) theme1,"
    
        if (condition2 !== "" && condition1 !== "") {
    
            requette += "( SELECT COALESCE(SUM(i_pnew_pop),0) theme12 FROM maille.mailles indicateur WHERE " + condition1 + " AND " + condition2 + " ";
            if (condition3 !== "")
                requette += " AND NOT (" + condition3 + ") ";
    
            requette += " AND " + filtre + ") theme12,";
        } else
            requette += "(SELECT 0 as theme12) theme12,"
    
        if (condition2 !== "") {
            requette += "( SELECT COALESCE(SUM(i_pnew_pop),0) theme2 FROM maille.mailles indicateur WHERE " + condition2;
            if (condition1 !== "")
                requette += " AND NOT (" + condition1 + ")";
            if (condition3 !== "")
                requette += " AND NOT (" + condition3 + ")";
    
            requette += " AND " + filtre + ") theme2,";
        } else
            requette += "(SELECT 0 as theme2) theme2,"
    
        if (condition2 !== "" && condition3 !== "") {
    
            requette += "( SELECT COALESCE(SUM(i_pnew_pop),0) theme23 FROM maille.mailles indicateur WHERE " + condition2 + " AND " + condition3 + " ";
            if (condition1 !== "")
                requette += " AND NOT (" + condition1 + ") ";
    
            requette += " AND " + filtre + ") theme23,";
        } else
            requette += "(SELECT 0 as theme23) theme23,"
    
        if (theme3) {
            requette += "( SELECT COALESCE(SUM(i_pnew_pop),0) theme3 FROM maille.mailles indicateur WHERE " + condition3;
            if (condition1 !== "")
                requette += " AND NOT (" + condition1 + ")";
            if (condition2 !== "")
                requette += " AND NOT (" + condition2 + ")";
    
            requette += " AND " + filtre + ") theme3,";
        } else
            requette += "(SELECT 0 as theme3) theme3,"
        if (condition3 !== "" && condition1 !== "") {
    
            requette += "( SELECT COALESCE(SUM(i_pnew_pop),0) theme13 FROM maille.mailles indicateur WHERE " + condition1 + " AND " + condition3 + " ";
            if (condition2 !== "")
                requette += " AND NOT (" + condition2 + ") ";
    
            requette += " AND " + filtre + ") theme13,";
        } else
            requette += "(SELECT 0 as theme13) theme13,"
        if (condition3 !== "" && condition1 !== "" && condition2 !== "") {
    
            requette += "( SELECT COALESCE(SUM(i_pnew_pop),0) theme123 FROM maille.mailles indicateur WHERE " + condition1 + " AND " + condition2 + " AND " + condition3;
    
            requette += " AND " + filtre + ") theme123,";
        } else
            requette += "(SELECT 0 as theme123) theme123,"
    
        requette = requette.substring(0, requette.length - 1);
        var result = await fetch(config.serveur + "bdd/maille/" + requette)
        var data = await result.json();
        var donneegraphe = [];
        var couleurs = [];
        if (typeof data[0] !== 'undefined') {
            var vide = parseFloat(data[0].total) - parseFloat(data[0].theme1) - parseFloat(data[0].theme12) - parseFloat(data[0].theme2) - parseFloat(data[0].theme23) - parseFloat(data[0].theme3) - parseFloat(data[0].theme13) - parseFloat(data[0].theme123);
            if (vide > 0.01) {
                donneegraphe.push({ name: "Vide", y: vide });
                couleurs.push("#FFFFFF")
            }

            if (parseFloat(data[0].theme1) !== 0) {
                donneegraphe.push({ name: donneesvariable1.nomafficher.replace("$$", donneesvariable1.annee), y: parseFloat(data[0].theme1) });
                couleurs.push("rgb(" + config.couleur_theme1[0] + "," + config.couleur_theme1[1] + "," + config.couleur_theme1[2] + ")");
            }
            if (parseFloat(data[0].theme12) !== 0) {
                donneegraphe.push({ name: donneesvariable1.nomafficher.replace("$$", donneesvariable1.annee) + " et " + donneesvariable2.nomafficher.replace("$$", donneesvariable2.annee), y: parseFloat(data[0].theme12) });
                couleurs.push("rgb(" + config.couleur_theme12[0] + "," + config.couleur_theme12[1] + "," + config.couleur_theme12[2] + ")");
            }
            if (parseFloat(data[0].theme2) !== 0) {
                donneegraphe.push({ name: donneesvariable2.nomafficher.replace("$$", donneesvariable2.annee), y: parseFloat(data[0].theme2) });
                couleurs.push("rgb(" + config.couleur_theme2[0] + "," + config.couleur_theme2[1] + "," + config.couleur_theme2[2] + ")");
            }
            if (parseFloat(data[0].theme23) !== 0) {
                donneegraphe.push({ name: donneesvariable2.nomafficher.replace("$$", donneesvariable2.annee) + " et " + donneesvariable3.nomafficher.replace("$$", donneesvariable3.annee), y: parseFloat(data[0].theme23) });
                couleurs.push("rgb(" + config.couleur_theme23[0] + "," + config.couleur_theme23[1] + "," + config.couleur_theme23[2] + ")");
            }
            if (parseFloat(data[0].theme3) !== 0) {
                donneegraphe.push({ name: donneesvariable3.nomafficher.replace("$$", donneesvariable3.annee), y: parseFloat(data[0].theme3) });
                couleurs.push("rgb(" + config.couleur_theme3[0] + "," + config.couleur_theme3[1] + "," + config.couleur_theme3[2] + ")");
            }
            if (parseFloat(data[0].theme13) !== 0) {
                donneegraphe.push({ name: donneesvariable1.nomafficher.replace("$$", donneesvariable1.annee) + " et " + donneesvariable3.nomafficher.replace("$$", donneesvariable3.annee), y: parseFloat(data[0].theme13) });

                couleurs.push("rgb(" + config.couleur_theme13[0] + "," + config.couleur_theme13[1] + "," + config.couleur_theme13[2] + ")");
            }
            if (parseFloat(data[0].theme123) !== 0) {
                donneegraphe.push({ name: donneesvariable1.nomafficher.replace("$$", donneesvariable1.annee) + ", " + donneesvariable2.nomafficher.replace("$$", donneesvariable2.annee) + " et " + donneesvariable3.nomafficher.replace("$$", donneesvariable3.annee), y: parseFloat(data[0].theme123) });
                couleurs.push("rgb(" + config.couleur_theme123[0] + "," + config.couleur_theme123[1] + "," + config.couleur_theme123[2] + ")");
            }


            return {
                chart: {
                    plotBackgroundColor: null,
                    plotBorderWidth: null,
                    plotShadow: false,
                    type: 'pie',
                    animation: !(fonctionfincreation != null && typeof fonctionfincreation == "function"),

                },
                title: {
                    text: "Répartition population/couleur dans " + (terriroire!=="bdr" ? "la métropole" : "les Bouches du Rhône"),
                    style: {
                        'fontSize': agrandir ? '20px' : '12px'
                    }
                },
                tooltip: {
                    pointFormat: agrandir ? '{point.name} <b>{point.percentage:.1f}%</b>' : '<b>{point.percentage:.1f}%</b>',
                    style: {
                        'fontSize': agrandir ? '14px' : '10px'
                    }
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: 'pointer',
                        dataLabels: {
                            enabled: true,
                            format: agrandir ? '{point.name}: <b>{point.percentage:.1f}%</b>' : '<b>{point.percentage:.1f}%</b>',
                            style: {
                                'fontSize': agrandir ? '14px' : '8px'
                            }
                        },
                        showInLegend: false,
                        colors: couleurs,
                        animation: !(fonctionfincreation != null && typeof fonctionfincreation == "function"),
                        borderColor: '#000000',
                    },
                    series: {
                        events: {
                            afterAnimate: function () {
                                if (fonctionfincreation != null && typeof fonctionfincreation == "function") {
                                    //console.log("2")
//                                            fonctionfincreation();
                                }
                            }
                        }
                    }
                },
                series: [{
                        name: 'Brands',
                        colorByPoint: true,
                        data: donneegraphe
                    }],
                credits: {
                    enabled: false
                }
            }
        }

    }
    else {
        return "";
    }
}
